import { render, staticRenderFns } from "./agam_MonthlyReleaseDetails.vue?vue&type=template&id=8aa88bc2&"
import script from "./agam_MonthlyReleaseDetails.vue?vue&type=script&lang=js&"
export * from "./agam_MonthlyReleaseDetails.vue?vue&type=script&lang=js&"
import style0 from "./agam_MonthlyReleaseDetails.vue?vue&type=style&index=0&id=8aa88bc2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports